enum VehicleType {
  CAR = 1,
  BICYCLE = 2,
  MOTORCYCLE = 3,
  EXCAVATOR = 4,
}

export default VehicleType;

export const BIKE_TYPES = [VehicleType.BICYCLE, VehicleType.MOTORCYCLE];